import { apiRequest, handleCall } from 'syft-acp-core/api/call'

export const fetchBankHolidayRegions = ({ payload }) =>
  new Promise((resolve, reject) => {
    const req = apiRequest({ path: `/countries/${payload.countryCode}/bank_holiday_regions` })
    handleCall(req, resolve, reject)
  })
